import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "text-h3 text-bold" }
const _hoisted_4 = {
  class: "col-6 text-right",
  style: {"align-self":"flex-end"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_loader = _resolveComponent("loader")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, { class: "posts-card" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_toolbar, { class: "text-primary" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar_title, null, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                to: `clients/${_ctx.clientId}/posts`,
                class: "link text-primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Social Posts ")
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_icon, {
            name: "fa fa-images",
            size: "sm"
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_separator),
      _createVNode(_component_q_card_section, null, {
        default: _withCtx(() => [
          _createVNode(_component_loader, { task: _ctx.task }, null, 8, ["task"]),
          _withDirectives(_createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.numPosts), 1),
              _createTextVNode(" Posts ")
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_q_btn, {
                label: "View Social Posts",
                to: `clients/${_ctx.clientId}/posts`,
                flat: "",
                rounded: ""
              }, null, 8, ["to"])
            ])
          ], 512), [
            [_vShow, _ctx.numPosts !== null]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}